import { createAsyncThunk } from '@reduxjs/toolkit';
import { AccountTypeConversion } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { ConvertAccountType } from './interface';

export const convertAccountType = createAsyncThunk(
  'accountTypeConversion/convertAccountType',
  async (values: ConvertAccountType, { rejectWithValue }) => {
    try {
      const response = await AccountTypeConversion.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

